// Fila de KPIs del reporte. Reutiliza el primitivo Stat (mismo look que las
// métricas de QuickRepliesSettings) y recibe SOLO primitivos: está bajo memo y
// así el overlay de "refrescando" del contenedor no la re-renderiza en vano.

import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  MessagesSquare,
  MessageCircle,
  Clock,
  CheckCircle2,
  FolderPlus,
  Timer,
  TimerReset,
} from "lucide-react";
import { Stat } from "../../../../components/ui/Stat";
import { formatInt, formatMinutes } from "./format";

/**
 * @param {object} props - todos primitivos; los tiempos pueden venir null
 *   (sin datos suficientes) y se muestran como "—".
 */
function KpiCards({
  total,
  abiertas,
  pendientes,
  resueltas,
  casosNuevos,
  primeraRespuestaMin,
  resolucionMin,
}) {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3">
      <Stat
        label={t("Total")}
        value={formatInt(total)}
        hint={t("conversaciones")}
        icon={<MessagesSquare aria-hidden="true" />}
        tone="brand"
      />
      <Stat
        label={t("Abiertas")}
        value={formatInt(abiertas)}
        hint={t("en atención")}
        icon={<MessageCircle aria-hidden="true" />}
        tone="info"
      />
      <Stat
        label={t("Pendientes")}
        value={formatInt(pendientes)}
        hint={t("sin atender")}
        icon={<Clock aria-hidden="true" />}
        tone="warning"
      />
      <Stat
        label={t("Resueltas")}
        value={formatInt(resueltas)}
        hint={t("en el período")}
        icon={<CheckCircle2 aria-hidden="true" />}
        tone="success"
      />
      <Stat
        label={t("Casos nuevos")}
        value={formatInt(casosNuevos)}
        hint={t("aperturas y reaperturas")}
        icon={<FolderPlus aria-hidden="true" />}
        tone="neutral"
      />
      <Stat
        label={t("1.ª respuesta")}
        value={formatMinutes(primeraRespuestaMin)}
        hint={t("promedio")}
        icon={<Timer aria-hidden="true" />}
        tone="info"
      />
      <Stat
        label={t("Resolución")}
        value={formatMinutes(resolucionMin)}
        hint={t("promedio")}
        icon={<TimerReset aria-hidden="true" />}
        tone="success"
      />
    </div>
  );
}

export default memo(KpiCards);
